 <template>
 <Section id="postcard-section" class="postcard">
    <div class="componata-container --is-narrow">
      <SectionHeader>
        <template v-slot:title>Von uns handgeschriebene Grußkarte</template>
        <template v-slot:description>
          <p>Ob Lebensmotto, eine kleine Anekdote oder ein paar nette Worte: mit Ihrer Grußnachricht ergänzen Sie eine ganz persönliche Note. Unsere Mitarbeiter schreiben diese handschriftlich auf das gewählte Kartenmotiv.</p>
        </template>
      </SectionHeader>
    </div>

    <div class="componata-container">
      <img src="@/assets/images/landing-page/handwrite-seal.svg" class="postcard__seal" alt="Schönschrift garantiert!" data-aos="zoom-out" data-aos-delay="3000" loading="lazy">

      <ul class="postcard__deck">
        <li class="postcard__card" data-aos="fade-left" data-aos-delay="600" data-aos-duration="200">
          <div>
            <img
              :src="`https://cdn.componata.de/wp-content/uploads/2021/10/componata_postkarte_11.png?format=${webPFormat('jpeg')}&width=700&quality=80&compression=6`"
              alt="Hurra"
              loading="lazy"
            >
          </div>
        </li>
        <li class="postcard__card" data-aos="fade-left" data-aos-delay="500" data-aos-duration="200">
          <div>
            <img
              :src="`https://cdn.componata.de/wp-content/uploads/2021/10/componata_postkarte_12.png?format=${webPFormat('jpeg')}&width=700&quality=80&compression=6`"
              alt="Glückwunsch"
            >
          </div>
        </li>
        <li class="postcard__card" data-aos="fade-up">
          <div>
            <img
              :srcset="`
              ${require('@/assets/images/landing-page/handwriting@2x.png')}?format=${webPFormat('png')}&width=1080&nearlossless=1&compression=4 1080w,
              ${require('@/assets/images/landing-page/handwriting@2x.png')}?format=${webPFormat('png')}&width=540&nearlossless=1&compression=4 540w
            `"
              :src="`${require('@/assets/images/landing-page/handwriting@2x.png')}?format=${webPFormat('png')}&width=540&nearlossless=1&compression=4`"
              alt="Handgeschriebene Nachricht"
              loading="lazy"
            >
          </div>
        </li>
        <li class="postcard__card" data-aos="fade-right" data-aos-delay="700" data-aos-duration="200">
          <div>
            <img
              :src="`https://cdn.componata.de/wp-content/uploads/2021/10/componata_postkarte_14.png?format=${webPFormat('jpeg')}&width=700&quality=80&compression=6`"
              alt="Oh Happy Day!"
              loading="lazy"
            >
          </div>
        </li>
        <li class="postcard__card" data-aos="fade-right" data-aos-delay="800" data-aos-duration="200">
          <div>
            <img
              :src="`https://cdn.componata.de/wp-content/uploads/2021/10/componata_postkarte_05.png?format=${webPFormat('jpeg')}&width=700&quality=80&compression=6`"
              alt="Alles Wird Gut"
              loading="lazy"
            >
          </div>
        </li>
      </ul>

      <div class="postcard__cta">
        <p>Vielfältige Auswahl von über <b>30 Motiven!</b></p>

        <Button @click="scrollTo('present-main')" type="button" appearance="primary" class="--is-large">Konfigurieren</Button>
      </div>
    </div>
  </Section>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';
import { helperMixin } from '@/mixins/HelperMixin';

import Button from '@/components/Common/Button';
import Section from '@/components/PresentPage/Section';
import SectionHeader from '@/components/PresentPage/SectionHeader';

export default {
  name: 'Postcard',
  mixins: [UiMixin, helperMixin],
  components: {
    Button,
    Section,
    SectionHeader,
  }
};
</script>

<style lang="scss" scoped>
/**
 * Postcard
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc The postcard and its feature's section
 * @since 2020-10-28
**/

$component: 'postcard';

.#{$component} {
  position: relative;
  overflow-x: hidden;
  background: #FFF5F5 url('~@/assets/images/landing-page/bgr-sparks.svg') center bottom no-repeat;
  background-size: cover;
  z-index: 0;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 400px;
    @include linear-gradient(to bottom, #FFF5F5, rgba(255, 255, 255, 0));
    z-index: -1;
  }

  // Relative container for positioning the seal
  .componata-container:nth-child(2) {
    position: relative;
  }

  &__seal {
    // display: none;
    position: absolute;
    @include rfs(- map-get($spacers, 6) * 2, top);
    @include rfs(map-get($spacers, 6), right);
    width: 150px;
    height: auto;
    @include imageRendering;
  }

  // Deck
  &__deck {
    @include unlist;

    display: flex;
    justify-content: center;
    // Add more padding bottom to balance the height of this element regarding the negative translate of some cards
    @include padding-bottom(map-get($spacers, 6));
    @include margin-top(map-get($spacers, 5) * 5);
    margin-left: auto;
    margin-right: auto;
  }

  &__card {
    position: relative;
    flex: 0 0 310px;
    height: auto;
    z-index: 0;

    > div {
      background-color: $white;
      box-shadow: 5px 5px 22px 1px rgba(0, 0, 0, 0.06);
    }

    img {
      max-width: 100%;
      @include imageRendering;
    }

    & + & {
      // outline: 1px solid blue;
      margin-left: -80px;
    }

    &:nth-child(1) div {
      transform: rotate(-30deg) translateY(80px);
    }

    &:nth-child(2) div {
      transform: rotate(-15deg);
    }

    &:nth-child(3) { // Handwriting hand
      z-index: 4;

      div {
        width: 310px;
        height: 310px;
        z-index: 4;
        transform: translateY(-80px);
        // overflow: hidden;
        background-color: unset;

        img {
          max-width: unset;
          width: 548px;
          margin-top: -3px;
          margin-left: -44px;
        }
      }
    }

    &:nth-child(4) div {
      transform: rotate(15deg);
    }

    &:nth-child(5) {
      z-index: -1;

      div {
        position: relative;
        transform: rotate(30deg) translateY(80px);
      }
    }
  }

  // CTA
  &__cta {
    text-align: center;

    p {
      @include margin-bottom(map-get($spacers, 5));
      @include font-size($font-size-lg);
      font-weight: $font-weight-light;
    }

    ::v-deep .btn {
      display: inline-block;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__seal {
      @include rfs(- map-get($spacers, 6) * 3, top);
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__seal {
      width: 100px;
      // @include rfs(map-get($spacers, 6) * 8, top);
    }

    &__deck {
      @include margin-top(map-get($spacers, 4) * 6);
      @include margin-bottom(map-get($spacers, 4) * 8);
    }

    &__card {
      flex: 0 0 190px;

      &:nth-child(3) { // Handwriting hand
        div {
          width: 190px;
          height: 190px;
          transform: translateY(-40px);

          img {
            width: 339px;
            margin-top: -2px;
            margin-left: -31px;
          }
        }
      }
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__seal {
      width: 80px;
      top: unset;
      left: 0;
      right: 0;
      @include rfs(map-get($spacers, 6) * 5, bottom);
      margin-left: auto;
      margin-right: auto;
    }

    &__deck {
      @include margin-top(map-get($spacers, 4) * 10);
    }
  }
}
</style>
